<script lang="ts">
  import { querystring } from 'svelte-spa-router';
  import TradingCanvasBackground from '$lib/components/login/TradingCanvasBackground.svelte';
  import { Button } from '$lib/components/ui/button';
  import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
  } from '$lib/components/ui/card';

  const errorMessages: Record<string, string> = {
    not_allowed: 'Your Google account is not authorized to access this dashboard.',
    oauth_failed: 'OAuth flow failed. Please try again.',
    invalid_userinfo: 'Google did not return a valid email. Please try again.',
    oauth_misconfigured: 'OAuth is not configured. Contact the admin.',
  };

  function getError(qs: string | undefined): string | null {
    if (!qs) return null;
    const params = new URLSearchParams(qs);
    const key = params.get('error');
    if (!key) return null;
    return errorMessages[key] ?? `Error: ${key}`;
  }

  let errorMsg = $derived(getError($querystring));

  function login(): void {
    window.location.href = '/api/auth/google';
  }
</script>

<main class="bg-background relative min-h-screen overflow-hidden">
  <!-- Trading canvas background animado -->
  <TradingCanvasBackground density="high" speed="fast" />

  <!-- Overlay oscuro para legibilidad del card -->
  <div class="pointer-events-none absolute inset-0 bg-black/55 backdrop-blur-[1px]"></div>

  <div class="relative z-10 grid min-h-screen place-items-center px-4">
    <Card
      class="bg-card-hero border-gold/30 lifted-edge-gold shadow-luxury-gold w-full max-w-md rounded-xl p-3 backdrop-blur-xl"
    >
      <CardHeader class="text-center">
        <img
          src="/rabbyt-mascot.png"
          alt="RabbytHole"
          class="mx-auto mb-3 size-36 drop-shadow-[0_4px_12px_rgba(216,120,7,0.4)]"
        />
        <CardTitle class="text-display text-4xl">RabbytHole Dashboard</CardTitle>
        <CardDescription class="text-base">
          Sign in with your Google account to access the dashboard.
        </CardDescription>
      </CardHeader>

      <CardContent class="flex flex-col gap-4">
        {#if errorMsg}
          <div
            role="alert"
            class="animate-shake border-destructive/40 bg-destructive/10 text-destructive rounded-md border px-3 py-2 text-sm"
          >
            {errorMsg}
          </div>
        {/if}

        <Button
          onclick={login}
          size="lg"
          class="h-12 w-full text-base [&_svg]:!size-8 [&_svg]:!shrink-0"
        >
          <svg viewBox="0 0 48 48" aria-hidden="true">
            <path
              fill="#FFC107"
              d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.3 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.6-.4-3.5z"
            />
            <path
              fill="#FF3D00"
              d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.3 29.4 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"
            />
            <path
              fill="#4CAF50"
              d="M24 44c5.3 0 10.1-2 13.7-5.3l-6.3-5.2C29.5 35 26.9 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.6 5.1C9.5 39.7 16.1 44 24 44z"
            />
            <path
              fill="#1976D2"
              d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.5l6.3 5.2C40.8 36 44 30.7 44 24c0-1.3-.1-2.6-.4-3.5z"
            />
          </svg>
          Sign in with Google
        </Button>

        <p class="text-muted-foreground text-center text-xs">
          Only authorized accounts can sign in.
        </p>
      </CardContent>
    </Card>
  </div>
</main>
